import React from 'react';
import { ResidentRiskTable } from '../components/ResidentRiskTable';
import { ArrowLeftIcon } from 'lucide-react';
interface ReportPageProps {
  onBackToOverview: () => void;
}
export const ReportPage: React.FC<ReportPageProps> = ({
  onBackToOverview
}) => {
  return <main className="flex-1 overflow-y-auto bg-gray-50 p-6" data-id="element-325">
      <div className="mb-6" data-id="element-326">
        <div className="flex items-center justify-between mb-4" data-id="element-327">
          <h1 className="text-2xl font-bold" data-id="element-328">Fall Risk Assessment Report</h1>
          <button onClick={onBackToOverview} className="flex items-center px-4 py-2 bg-[#1f58b0] text-white rounded-md hover:bg-[#255db7] transition-colors" data-id="element-329">
            <ArrowLeftIcon className="h-4 w-4 mr-2" data-id="element-330" />
            Back to Overview
          </button>
        </div>
        <p className="text-gray-600 mb-4" data-id="element-331">
          This report identifies residents who may be at elevated risk for falls
          based on their fall history, medication profile, mobility assessments,
          and other health factors.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-332">
          <div className="bg-white p-4 rounded-lg shadow" data-id="element-333">
            <h3 className="text-sm font-medium text-gray-500" data-id="element-334">
              Total Residents at Risk
            </h3>
            <p className="text-2xl font-bold text-[#1f58b0]" data-id="element-335">8</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow" data-id="element-336">
            <h3 className="text-sm font-medium text-gray-500" data-id="element-337">
              Average Falls per Resident
            </h3>
            <p className="text-2xl font-bold text-[#f97c6b]" data-id="element-338">2.1</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow" data-id="element-339">
            <h3 className="text-sm font-medium text-gray-500" data-id="element-340">
              Residents Requiring Intervention
            </h3>
            <p className="text-2xl font-bold text-[#f6d052]" data-id="element-341">5</p>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow" data-id="element-342">
        <div className="p-4 border-b" data-id="element-343">
          <h2 className="text-lg font-semibold" data-id="element-344">Residents at Risk for Falls</h2>
          <p className="text-sm text-gray-500" data-id="element-345">
            Sorted by number of falls in the past 3 months
          </p>
        </div>
        <ResidentRiskTable data-id="element-346" />
      </div>
    </main>;
};